import { Label } from "@/components/ui/label";
import React from "react";
import { AlertCircle } from "lucide-react";

type FormFieldProps = {
  id?: string;
  label: React.ReactNode;
  error?: string;
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'fieldset';
};

export function FormField({
  id,
  label,
  error,
  children,
  className,
  as = 'div',
}: FormFieldProps) {
  const Component = as;

  return (
    <Component className={`space-y-2 ${className ?? ""}`}>
      {as === 'fieldset' ? (
        <legend className="block font-sans text-lg font-semibold text-left">
          {label}
        </legend>
      ) : (
        <Label
          htmlFor={id}
          className="block font-sans text-lg font-semibold text-left cursor-pointer"
        >
          {label}
        </Label>
      )}
      {children}
      {error && (
        <span className="flex items-start gap-1 text-red-500 text-md" role="alert">
          <AlertCircle className="w-4 h-4 mt-1" />
          <span>{error}</span>
        </span>
      )}
    </Component>
  );
}
